module.exports = ":root{--lui-desktopnavigation-height:calc(5 * var(--lui-padding));--lui-desktopnavigation-padding-x:calc(3 * var(--lui-padding))}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-desktopnavigation/theme/lui-desktopnavigation.global.scss
// module id = 208
// module chunks = 0 1 34